import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { IpoXdoIgrnQueueContainer } from '../../../../../../models/aggregates/erp/index';

@Injectable({
    providedIn: 'root'
})
export class IpoXdoIgrnQueueService extends BaseApiTemplateService<IpoXdoIgrnQueueContainer> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ipo-xdo-igrn-queues/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ipo-xdo-igrn-queues/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ipo-xdo-igrn-queues/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
    }
}
